module.exports = __webpack_public_path__ + "static/media/spe_study_fg.d4ee01c8.png";